import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { canonicalUrl, isPublicSeoPath, SEO_LANGUAGES } from "@/lib/seo-url";

/** Owns URL identity for every route, including while lazy pages load. */
export default function RouteSeo() {
  const { pathname } = useLocation();
  if (!isPublicSeoPath(pathname)) {
    return (
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    );
  }

  const url = canonicalUrl(pathname);
  return (
    <Helmet>
      <link rel="canonical" href={url} />
      {SEO_LANGUAGES.map((lang) => (
        <link key={lang} rel="alternate" hrefLang={lang} href={url} />
      ))}
      <meta property="og:url" content={url} />
    </Helmet>
  );
}